// extracted by mini-css-extract-plugin
export default {"header":"header-gf9Ds","body":"body-DYbH_","alert":"alert-TbRqe"};